import { render, staticRenderFns } from "./alarmrecord.vue?vue&type=template&id=13e86e8c&"
import script from "./alarmrecord.vue?vue&type=script&lang=js&"
export * from "./alarmrecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports